import { onMessageListener } from "libraries/firebaseInit";

import axiosConfig from "../api/axios.config";

const bootstrapApp = async () => {
  await axiosConfig()
  await onMessageListener()
}
export default bootstrapApp
